"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
require("antd/dist/antd.less");
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../..");
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var StyledRadio = styled_components_1.default(antd_1.Radio)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.ant-radio-wrapper {\n    margin-right: 29px;\n    align-items: flex-start;\n    margin-bottom: ", ";\n    & > *:last-child {\n      font-size: 12px;\n      font-weight: 500;\n      line-height: 100%;\n      text-transform: uppercase;\n      align-self: center;\n      margin-top: 5px;\n      color: #3b3b3b;\n    }\n    @media only screen and (max-width: 648px) {\n      display: block;\n      margin-bottom: 10px;\n    }\n  }\n  .ant-radio-inner {\n    width: 20px;\n    height: 20px;\n    border: 2px solid #2362a2;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n  }\n  span.ant-radio + * {\n    padding-left: 15px;\n  }\n  .ant-radio-inner::after {\n    width: 20px;\n    height: 20px;\n    margin-top: -10px;\n    margin-left: -10px;\n  }\n"], ["\n  &.ant-radio-wrapper {\n    margin-right: 29px;\n    align-items: flex-start;\n    margin-bottom: ", ";\n    & > *:last-child {\n      font-size: 12px;\n      font-weight: 500;\n      line-height: 100%;\n      text-transform: uppercase;\n      align-self: center;\n      margin-top: 5px;\n      color: #3b3b3b;\n    }\n    @media only screen and (max-width: 648px) {\n      display: block;\n      margin-bottom: 10px;\n    }\n  }\n  .ant-radio-inner {\n    width: 20px;\n    height: 20px;\n    border: 2px solid #2362a2;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n  }\n  span.ant-radio + * {\n    padding-left: 15px;\n  }\n  .ant-radio-inner::after {\n    width: 20px;\n    height: 20px;\n    margin-top: -10px;\n    margin-left: -10px;\n  }\n"])), function (props) { return props.withGap && '10px'; });
var RadioButtonsField = function (_a) {
    var name = _a.name, label = _a.label, dataList = _a.dataList, loading = _a.loading, error = _a.error, toolTip = _a.toolTip, disabled = _a.disabled, onClick = _a.onClick, style = _a.style, withGap = _a.withGap;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    react_1.useEffect(function () {
        var def = dataList === null || dataList === void 0 ? void 0 : dataList.find(function (el) { return el.default; });
        if (def)
            helpers.setValue(def.value);
    }, []);
    var handleClick = function (e) {
        if (onClick)
            onClick(e.target.value);
        helpers.setValue(e.target.value);
    };
    return (react_1.default.createElement("fieldset", { name: name, style: style },
        react_1.default.createElement(Field_1.default, { loading: loading, error: error },
            label && (react_1.default.createElement(Label_1.default, { htmlFor: name },
                label,
                toolTip && react_1.default.createElement(__1.InformationIcon, { toolTip: toolTip }))),
            react_1.default.createElement(antd_1.Radio.Group, { onChange: handleClick, value: field.value, size: "large" }, dataList.map(function (item, index) { return (
            // eslint-disable-next-line react/no-array-index-key
            react_1.default.createElement(StyledRadio, { key: name + "-" + index, value: item.value, id: __1.NormalizeString(item.label), disabled: disabled, withGap: withGap }, item.label)); })))));
};
RadioButtonsField.defaultProps = {
    loading: false,
    error: undefined,
    toolTip: undefined,
    label: undefined,
    disabled: undefined,
    onClick: undefined,
    style: undefined,
    withGap: undefined,
};
exports.default = RadioButtonsField;
var templateObject_1;
